module.exports = __webpack_public_path__ + "assets/img/logo.46515220.png";